// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"20073794","80":"590a351d","205":"982b1fb1","364":"a5895ace","468":"d2a6e789","528":"6142f20f","570":"504f6b3e","585":"f336aab7","664":"0e7a81a0","990":"de619836"}[chunkId] + ".chunk.js";
};